import { render, staticRenderFns } from "./MotoristasForm.vue?vue&type=template&id=3e96e2fa"
import script from "./MotoristasForm.vue?vue&type=script&lang=js"
export * from "./MotoristasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports